<div class="filter-row flex justify-start gap-2">
  <p-select class="section-select"
            data-test="section-select"
            optionLabel="label"
            optionValue="value"
            placeholder="Select Section"
            [formControl]="sectionControl()"
            [options]="nav.sectionOptions()"
  />

  <div class="flex gap-2">
    <button pButton
            type="button"
            data-test="prev-section-button"
            outlined="true"
            severity="secondary"
            iconOnly
            [disabled]="nav.currentIndex() === 0"
            (click)="nav.goToPreviousSection()"
    >
      <i class="pi pi-chevron-up"></i>
    </button>
    <button pButton
            type="button"
            data-test="next-section-button"
            outlined="true"
            severity="secondary"
            iconOnly
            [disabled]="nav.currentIndex() === nav.sectionOptions().length - 1"
            (click)="nav.goToNextSection()"
    >
      <i class="pi pi-chevron-down"></i>
    </button>
  </div>
</div>
